export const DEV =
  !process.env.NODE_ENV || process.env.NODE_ENV === "development";

export const MAX_WIDTH = 1200;
export const MEDIUM_MAX_WIDTH = 1000;
export const TABLET_WIDTH = 1000;
export const NARROW_MAX_WIDTH = 800;
export const MOBILE_WIDTH = 600;
